import { getCurrentAppMode, AGENT_APP_MODE } from '../../modules/appMode';

export interface AppModeState {
  isAgentMode: boolean;
}

const initialState: AppModeState = {
  isAgentMode: getCurrentAppMode() === AGENT_APP_MODE,
};

export const name = 'appMode';

export default (state = initialState): AppModeState => state;
